import React, { createContext, useState } from 'react'
import GuestLayout from './Component'

// @ts-ignore
export const GuestLayoutContext = createContext<{
  setLogo: (logoUrl: string) => void
  setIsloading: (isLoading: boolean) => void
  setHeaderBG: (color: string) => void
}>({
  // @ts-ignore
  setLogo: (logoUrl: string) => null,
  setIsloading: (isLoading: boolean) => null,
  setHeaderBG: (color: string) => null
})

export const GuestLayoutProvider: React.FC = ({ children }) => {
  const [logo, setLogoState] = useState<string>('/images/logo-withe.svg')
  const [showPoweredByLogo, setShowPoweredByLogo] = useState<boolean>(false)
  const [isLoading, setIsLoadingState] = useState<boolean>(true)
  const [headerBG, setHeaderBG] = useState('')

  const setLogo = (logoUrl: string) => {
    setLogoState(logoUrl)
    setShowPoweredByLogo(true)
  }

  const setIsloading = (value: boolean) => {
    setIsLoadingState(value)
  }

  return (
    <GuestLayoutContext.Provider
      value={{
        setLogo,
        setIsloading,
        setHeaderBG
      }}
    >
      <GuestLayout isLoading={isLoading} logo={logo} showPoweredByLogo={showPoweredByLogo} headerBG={headerBG}>
        {children}
      </GuestLayout>
    </GuestLayoutContext.Provider>
  )
}
